import request from './http'
// lc-web
export function getSaasInfo (data) {
  return request({
    method: 'post',
    url: data.url,
    headers: {
      api_new_json: 'true',
      'Content-Type': 'application/x-www-form-urlencoded'
    // 'Content-Type': 'application/json;charset=UTF-8'
    },
    data: data.data
  })
}
